import { Routes } from "@angular/router";

export const PointOfSaleRoutes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import("@/app/domains/erp/checkout/pages/checkout-main/checkout-main.page").then(
				(m) => m.CheckoutMainPage
			),
	},
	{
		path: "cashier",
		loadComponent: () =>
			import("@/app/domains/erp/checkout/pages/cashier/cashier.page").then(
				(m) => m.CashierPage
			),
	},
	{
		path: "cashier-container",
		loadComponent: () =>
			import(
				"@/app/domains/erp/checkout/pages/cashier-container/cashier-container.page"
			).then((m) => m.CashierContainerPage),
	},
	{
		path: "open-cash-register",
		loadComponent: () =>
			import(
				"@/app/domains/erp/checkout/pages/open-cash-register/open-cash-register.page"
			).then((m) => m.OpenCashRegisterPage),
	},
	{
		// Resumen Z de un turno de caja (GMKS-237).
		path: "shift/:uid",
		loadComponent: () =>
			import(
				"@/app/domains/erp/checkout/pages/shift-summary/shift-summary.page"
			).then((m) => m.ShiftSummaryPage),
	},
	{
		path: "add-pos",
		loadComponent: () =>
			import(
				"@/app/domains/erp/checkout/pages/pos-assignment/add-pos/add-pos.page"
			).then((m) => m.AddPosPage),
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];
